// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"index_radioGroup__ipt1j"};